import styled from 'styled-components';

export const TooltipContent = styled.div`
  font-size: 12px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  a {
    font: 300 14px Roboto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 10px;
    height: 40px;
    color: var(--color-primary-light);
    text-decoration: none;
    transition: 0.2s;
    &:hover {
      background: var(--color-primary-light);
      color: #fff;
    }
  }
`;
